export default __webpack_public_path__ + "static/media/logo.221f6b13.svg";